import { lazy } from 'react';
import { DealViewExtensions } from '../components/Deals/views/DealViewExtensions';
import { PartnerViewExtensions } from '../components/Partners/views/PartnerViewExtensions';
import { LeadViewExtensions } from '../components/Leads/views/LeadViewExtensions';

const CommentsPanel = lazy(() => import('@ayocore/comments/client/CommentsPanel'));

/**
 * Опции регистрации вкладки «Комментарии».
 * По умолчанию все три выключены — комментарии и так доступны в Activity-панели,
 * отдельная вкладка избыточна. Инстанс может явно включить нужные:
 *
 * @example
 * registerCrmCommentsExtensions({ deal: true });
 */
export interface RegisterCrmCommentsExtensionsOptions {
  /** Показывать вкладку в DealView. */
  deal?: boolean;
  /** Показывать вкладку в PartnerView. */
  partner?: boolean;
  /** Показывать вкладку в LeadView. */
  lead?: boolean;
}

/**
 * Регистрирует вкладку «Комментарии» в DealView/PartnerView/LeadView.
 * Включается точечно через опции — по умолчанию ничего не регистрируется.
 */
export function registerCrmCommentsExtensions(
  options: RegisterCrmCommentsExtensionsOptions = {}
): void {
  if (options.deal) {
    DealViewExtensions.tabs.register(({ deal }) => ({
      value: 'crm-comments',
      label: 'Комментарии',
      content: <CommentsPanel entityUuid={deal.uuid} entityType='crm::DealRepository' />,
    }));
  }

  if (options.partner) {
    PartnerViewExtensions.tabs.register(({ partner }) => ({
      value: 'crm-comments',
      label: 'Комментарии',
      content: <CommentsPanel entityUuid={partner.uuid} entityType='crm::PartnerRepository' />,
    }));
  }

  if (options.lead) {
    LeadViewExtensions.tabs.register(({ lead }) => ({
      value: 'crm-comments',
      label: 'Комментарии',
      content: <CommentsPanel entityUuid={lead.uuid} entityType='crm::LeadRepository' />,
    }));
  }
}
